import Status from '../../enums/Status';
import * as types from '../actions/action-types';

export const initialState = {
  status: Status.NOT_STARTED,
  session: {},
  error: false,
  klarnaCustomerDetails: {},
};

export default function klarnaReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_KLARNA_STATUS:
      return {...state, status: action.status};

    case types.SET_KLARNA_ERROR: {
      const newState = {};
      newState.status = Status.ERROR;
      newState.error = action.error;
      return {...state, ...newState};
    }

    case types.SET_KLARNA_SESSION:
      return {...state, session: action.session};

    case types.SET_LOAD_KLARNA_CATEGORY_RESPONSE: {
      const newState = {};
      newState[action.categoryID] = {load: action.response};
      return {...state, ...newState};
    }

    case types.SET_AUTH_KLARNA_CATEGORY_RESPONSE: {
      const newState = {};
      newState[action.categoryID] = {...state[action.categoryID], auth: action.response};
      return {...state, ...newState};
    }

    case types.SET_KLARNA_CUSTOMER_DETAILS: {
      const updatedKlarnaCustomerDetails = {};
      updatedKlarnaCustomerDetails[action.fieldName] = action.fieldValue;
      return {...state, klarnaCustomerDetails: {...state.klarnaCustomerDetails, ...updatedKlarnaCustomerDetails}};
    }

    default:
      return state;
  }
}
